export const Styles = {
    copyButton: { textTransform: 'uppercase', borderRadius: '50px', width: '100%' },
    readOnlyField: { width: '425px' },
};
